function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withModifiers } from '../../decorators';

var Knob = function Knob(_ref) {
  var onStop = _ref.onStop,
      parentRef = _ref.parentRef,
      pos_x = _ref.pos_x,
      x = _ref.x;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dragging = _useState2[0],
      setDragging = _useState2[1];

  var _useState3 = useState(pos_x),
      _useState4 = _slicedToArray(_useState3, 2),
      _x = _useState4[0],
      setX = _useState4[1];

  var onStart = function onStart() {
    return setDragging(true);
  };

  var _onMove = function _onMove(e) {
    var parentRect = parentRef.current.getBoundingClientRect();
    var x = Math.min(Math.max(Math.round((e.clientX - parentRect.left) / (parentRect.right - parentRect.left) + 'e2'), 1), 100);

    if (x !== _x) {
      setX(x);
    }
  };

  var onMouseDown = function onMouseDown(e) {
    if (e.button !== 0) return;
    onStart(e);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    e.preventDefault();
  };

  var onMouseUp = function onMouseUp(e) {
    setDragging(false);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
    onStop && onStop(_x);
    e.preventDefault();
  };

  var onMouseMove = function onMouseMove(e) {
    _onMove(e);

    e.preventDefault();
  };

  var onTouchStart = function onTouchStart(e) {
    onStart(e.touches[0]);
    document.addEventListener('touchmove', onTouchMove, {
      passive: false
    });
    document.addEventListener('touchend', onTouchEnd, {
      passive: false
    });
    e.preventDefault();
  };

  var onTouchMove = function onTouchMove(e) {
    _onMove(e.touches[0]);

    e.preventDefault();
  };

  var onTouchEnd = function onTouchEnd(e) {
    setDragging(false);
    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('touchend', onTouchEnd);
    onStop && onStop(_x);
    e.preventDefault();
  };

  return React.createElement("div", _extends({
    className: "knob"
  }, {
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart
  }, {
    style: {
      position: 'absolute',
      left: dragging ? "".concat(_x, "%") : pos_x > 1.5 ? "".concat(pos_x, "%") : '1.5rem',
      touchAction: 'none'
    }
  }));
};

Knob.propTypes = {
  onStop: PropTypes.func,
  pos_x: PropTypes.number,
  x: PropTypes.number,
  parentRef: PropTypes.object
};
export default withModifiers(Knob);